import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Player } from '@app/_models/player';
import { PaginatedList } from '@app/_models/shared.model';


@Injectable({
  providedIn: 'root'
})
export class PlayersService {

  constructor(
    private http: HttpClient,
  ) { }

  getPlayer(id): Observable<Player> {
    const url = `${environment.apiUrl}/players/${id}/`;
    return this.http.get<Player>(url);
  }

  getPlayers(): Observable<Player[]> {
    const url = `${environment.apiUrl}/players/list/`;
    return this.http.get<Player[]>(url);
  }

  findPlayers(
    filter = '', sortOrder = 'username',
    pageNumber = 1, pageSize = 10, onlyUsers = 0): Observable<PaginatedList> {

    const url = `${environment.apiUrl}/players/list/`;

    return this.http.get<PaginatedList>(url, {
      params: new HttpParams()
        .set('search', filter)
        .set('ordering', sortOrder)
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
        .set('onlyUsers', onlyUsers.toString())
    });
  }
}
